import common from "@/public/common"
import { ajaxApi, downloadApi } from "@/server/index"
import moment from "moment"
import { getCookie } from "@/public/utils"

// 服务地址：供应商管理(新) srm-sqm（原 erp-srm-sqm-service，已迁移至 sap 域名）
var apiHost = common.sqmUrl

// 操作人信息（与 newsuppliersettlement/service.js 保持一致）
export const operatorData = {
    operator_id: getCookie("accountId") || "10",
    operator_name: getCookie("supplier_company_name") || "SCS系统",
    role_id_list: [0],
}

// ==================== 供货商品目录 - 列表 ====================

// 供货商品目录列表查询
// 文档: /supplier-item/item-price/page-query  POST json
// 请求字段与现有页面字段映射: page_index -> no, page_size -> size, sigo_name -> item_code_name,
// supplier_product_code -> product_code_name, is_bind -> is_no_product_relation
// 返回: data.data.data[] 数据, data.data.count 总数
export const querySupplierItemListApi = async (params) => {
    return await ajaxApi({
        url: `${apiHost}supplier-item/item-price/page-query`,
        params,
    })
}

// 供货商品目录导出（下载）
// 文档: /supplier-item/item-price/download  POST json blob
export const downloadProductRelationApi = (params) => {
    return downloadApi(
        apiHost + 'supplier-item/product-relation/download',
        params,
        '供货商品目录' + moment().format('YYYYMMDDHHmmss') + '.xls'
    )
}

// 供货商品目录模板下载
// 文档: /supplier-item/item-price/download-template  POST blob 无请求体
export const downloadRelationTemplateApi = () => {
    return downloadApi(
        apiHost + 'supplier-item/product-relation/download-template',
        null,
        '供货商品目录模板' + moment().format('YYYYMMDDHHmmss') + '.xls'
    )
}

// Excel 导入上传地址（供 antd Upload action 使用）
// 文档: /supplier-item/item-price/upload  POST form-data
// 上传额外字段: supplier_code, operator_id, operator_name 在 list.js 的 Upload data 中拼接
export const uploadProductRelationUrl = apiHost + 'supplier-item/product-relation/upload'

// ==================== 供货商品目录 - 详情 ====================

// 供货商品货品关联信息查询
// 文档: /supplier-item/item-product/query  POST json
// 请求: supplier_code, item_code_list[]
// 返回: data.product_list[]（每条含 product_code/product_name + product_relation_list[]）
export const querySupplierProductListApi = async (params) => {
    return await ajaxApi({
        url: `${apiHost}supplier-item/item-product/query`,
        params,
    })
}

// 供应商货品编码关系修改（绑定/解绑）
// 文档: /supplier-item/product-relation/update  POST json
// 请求: operator_id, operator_name, role_id_list, supplier_code, item_code, product_list[]
export const updateSupplierProductCodeApi = async (params) => {
    return await ajaxApi({
        url: `${apiHost}supplier-item/product-relation/update`,
        params,
    })
}



// WEBPACK FOOTER //
// ./src/pages/supplierGood/service.js